import type { HomeExclusiveDrop } from './homeDrops';

/** Style-inspiration tiles for the home rail — moodboard language, not SKU names. */
export const HOME_POPULAR_DROPS: readonly HomeExclusiveDrop[] = [
  {
    name: 'Oversized tee mood',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/68/fe/f8/68fef885052e09d6a6446269f8b55404.jpg',
    slug: 'oversized-tee-mood',
    vibes: ['Minimalist', 'Classic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Inspiration only — shop live drops for similar vibes.',
  },
  {
    name: 'Retro graphic direction',
    category: 'Hoodie moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/90/ba/2b/90ba2b569a6cf0d67d76a2af13f574b8.jpg',
    slug: 'retro-graphic-direction',
    vibes: ['Streetwear', 'Classic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Editorial reference — not a live listing.',
  },
  {
    name: 'Street fit inspiration',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/bd/bc/89/bdbc893332d71b330f571ce631f8b766.jpg',
    slug: 'street-fit-inspiration',
    vibes: ['Streetwear'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Find this vibe in the shop.',
  },
  {
    name: 'Bold print mood',
    category: 'Sweatshirt moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/c0/a7/be/c0a7be3d7ee7d6ee51f7ac3880e5e5e5.jpg',
    slug: 'bold-print-mood',
    vibes: ['Artistic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Moodboard tile — explore similar drops.',
  },
  {
    name: 'Minimal everyday fit',
    category: 'Hoodie moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/e5/7f/f5/e57ff5b82224d6ed300e032aa8bcb653.jpg',
    slug: 'minimal-everyday-fit',
    vibes: ['Minimalist', 'Streetwear'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Layering idea — shop live hoodies.',
  },
  {
    name: 'Clean chest graphic idea',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/f4/8f/11/f48f118359871b62d44c0bafe9cf4961.jpg',
    slug: 'clean-chest-graphic-idea',
    vibes: ['Classic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Typography direction — not a product SKU.',
  },
  {
    name: 'Earth-tone layering',
    category: 'Sweatshirt moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/29/1c/35/291c352e3a5d6a6faf15c31a9c90bcd8.jpg',
    slug: 'earth-tone-layering',
    vibes: ['Artistic', 'Minimalist'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Palette inspiration for your next drop.',
  },
  {
    name: 'Loud front-print vibe',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/b3/6e/6c/b36e6c00c6d8c5a3ab167c4266808450.jpg',
    slug: 'loud-front-print-vibe',
    vibes: ['Streetwear', 'Artistic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Graphic energy — browse live listings.',
  },
  {
    name: 'Hoodie layering idea',
    category: 'Hoodie moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/1d/9d/08/1d9d086a7db00030229d9063ae727a62.jpg',
    slug: 'hoodie-layering-idea',
    vibes: ['Classic', 'Minimalist'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Street layering mood — shop hoodies.',
  },
  {
    name: 'Photo-print direction',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/84/25/9e/84259e91c13c7fe79a7f980e85a6f245.jpg',
    slug: 'photo-print-direction',
    vibes: ['Artistic'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Editorial photo reference.',
  },
  {
    name: 'Muted type mood',
    category: 'Sweatshirt moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/04/8b/c1/048bc1009547e451bb04b88bd867ab8a.jpg',
    slug: 'muted-type-mood',
    vibes: ['Minimalist'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Soft typography inspiration.',
  },
  {
    name: 'Streetwear stamp vibe',
    category: 'Tee moodboard',
    price: 0,
    compareAt: null,
    image: 'https://i.pinimg.com/736x/c7/62/de/c762decb73f50ff557a6d5ce6c35e909.jpg',
    slug: 'streetwear-stamp-vibe',
    vibes: ['Streetwear'],
    isExclusive: false,
    isLowStock: false,
    designer: 'Style reference',
    limited: 'Stamp-style graphic direction.',
  },
];

const INSPIRATION_CTAS = [
  'Explore similar drops',
  'Shop live listings',
  'Find this vibe',
] as const;

export function homeDropInspirationCta(index: number): string {
  return INSPIRATION_CTAS[index % INSPIRATION_CTAS.length];
}
